var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("v-data-table", {
        attrs: {
          items: _vm.fdPrmList,
          headers: _vm.headers,
          loading: _vm.fdPrmGetting,
          dense: "",
          "single-expand": ""
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function({ item, expand, isExpanded }) {
              return [
                _c("tr", [
                  _c("td", [_vm._v(_vm._s(item.stock_id))]),
                  _c("td", [_vm._v(_vm._s(item.category.description))]),
                  _c("td", [_vm._v(_vm._s(item.stock.description || null))]),
                  _c(
                    "td",
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "ma-0 pa-0",
                          attrs: {
                            color: `${
                              _vm.editItem === item.id
                                ? "blue-grey"
                                : "yellow darken-3"
                            }`,
                            text: "",
                            small: "",
                            dense: ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.$emit("input", item)
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-pencil")])],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ma-0 pa-0",
                          attrs: {
                            color: "purple darken-3",
                            text: "",
                            small: "",
                            dense: ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.$router.push({
                                name: "stocks.feeding-programs.show",
                                params: { feedingProgramId: item.id }
                              })
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-eye")])],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ma-0 pa-0",
                          class: isExpanded ? "is-expanded" : "",
                          attrs: {
                            color: "blue-grey",
                            text: "",
                            small: "",
                            dense: ""
                          },
                          on: {
                            click: function($event) {
                              return expand(!isExpanded)
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-chevron-down")])],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          },
          {
            key: "expanded-item",
            fn: function({ item }) {
              return [
                _c("tr", [
                  _c(
                    "td",
                    { attrs: { colspan: "4" } },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "3", align: "left" } },
                            [
                              _c(
                                "span",
                                { staticClass: "blue-grey--text mr-2" },
                                [_vm._v("Body Weight")]
                              ),
                              _c("small", { staticClass: "blue-grey--text" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.kilogramFormat(item.body_weight || 0)
                                  )
                                )
                              ]),
                              _c("v-divider")
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "3", align: "left" } },
                            [
                              _c(
                                "span",
                                { staticClass: "blue-grey--text mr-2" },
                                [_vm._v("Range")]
                              ),
                              _c("small", { staticClass: "blue-grey--text" }, [
                                _vm._v(
                                  _vm._s(item.day_start || "N/A") +
                                    " - " +
                                    _vm._s(item.day_end || "N/A")
                                )
                              ]),
                              _c("v-divider")
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "3", align: "left" } },
                            [
                              _c(
                                "span",
                                { staticClass: "blue-grey--text mr-2" },
                                [_vm._v("Expected Weight")]
                              ),
                              _c("small", { staticClass: "blue-grey--text" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.kilogramFormat(item.body_weight || 0)
                                  )
                                )
                              ]),
                              _c("v-divider")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }